import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import styles from './styles.module.css';
import cardClub from '../../../images/DragonTigerLion/cardClub.svg';
import cardSpade from '../../../images/DragonTigerLion/cardSpade.svg';
import cardHeart from '../../../images/DragonTigerLion/cardHeart.svg';
import cardDiamond from '../../../images/DragonTigerLion/cardDiamond.svg';
import cardSpade2 from '../../../images/DragonTigerLion/cardSpade2.svg';
import cardHeart2 from '../../../images/DragonTigerLion/cardHeart2.svg';
import cardClub2 from '../../../images/DragonTigerLion/cardClub2.svg';
import cardDiamond2 from '../../../images/DragonTigerLion/cardDiamond2.svg';
import FooterLinks from '../FooterLinks';
import { useLocation } from 'react-router-dom';
import GameScreen from './GameScreen';
import FlipClock from '../../FlipClock/FlipClock';
import useRoundLoader from '../../../api/useRoundLoader';
import RoundLoader from '../../Loader/RoundLoader';

const cardLabels = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];

const cardRows = cardLabels.map(label => ({
  label,
  values: ["12", "12", "12"],
  betTypes: [
    `dragon_${label.toLowerCase()}`,
    `tiger_${label.toLowerCase()}`,
    `lion_${label.toLowerCase()}`,
  ],
  icons: [
    [cardSpade2, cardDiamond2],
    [cardClub2, cardHeart2]
  ]
}));

const rowConfigs = [
  {
    label: 'Winner',
    values: ['2.94', '2.94', '2.94'],
    betTypes: ['dragon', 'tiger', 'lion'],
  },
  {
    label: 'Black',
    values: ['1.97', '1.97', '1.97'],
    icons: [cardClub, cardSpade],
    betTypes: ['dragon_black', 'tiger_black', 'lion_black'],
  },
  {
    label: 'Red',
    values: ['1.97', '1.97', '1.97'],
    icons: [cardHeart, cardDiamond],
    betTypes: ['dragon_red', 'tiger_red', 'lion_red'],
  },
  {
    label: 'Odd',
    values: ['1.83', '1.83', '1.83'],
    betTypes: ['dragon_odd', 'tiger_odd', 'lion_odd'],
  },
  {
    label: 'Even',
    values: ['2.12', '2.12', '2.12'],
    betTypes: ['dragon_even', 'tiger_even', 'lion_even'],
  },
];

const positions = ['Dragon', 'Tiger', 'Lion'];

const LockSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
    <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
  </svg>
);

// ─── Exposure Label Component ───────────────────────────────────────────────
const ExposureLabel = ({ value }) => {
  if (value === null || value === undefined) return null;
  const isNegative = value < 0;
  return (
    <Typography sx={{
      position: 'absolute',
      bottom: '2px',
      left: 0,
      fontSize: '10px',
      fontWeight: 600,
      color: isNegative ? '#ff4444' : '#00c853',
      textAlign: 'center',
      lineHeight: 1,
      width: '100%',
      display: 'block',
    }}>
      {value}
    </Typography>
  );
};

// ─── Main Component ──────────────────────────────────────────────────────────
function DragonTigerLion({ onBetSelect, locked, socketData, settledData, gameId = 7, hookExposureData }) {
  const [betDialogOpen, setBetDialogOpen] = useState(false);
  const [selectedBet, setSelectedBet] = useState(null);
  const [exposureData, setExposureData] = useState(null);
const [animTimer, setAnimTimer] = useState(null);
  const remainingTime = socketData?.remainingTime;
  const roundId = socketData?.roundId;


  const location = useLocation();

  // ─── Sync exposure from hook ────────────────────────────────────────────
useEffect(() => {
    if (hookExposureData === null) {
        setExposureData(null);
        return;
    }
    if (hookExposureData && hookExposureData.gameId === gameId) {
        setExposureData(hookExposureData);
    }
}, [hookExposureData, gameId]);
useEffect(() => {
  if (roundId) {
    setExposureData(null);
  }
}, [roundId]);
  

  // ─── Scroll to top on route change ─────────────────────────────────────
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  // ─── Exposure key → value ───────────────────────────────────────────────
  const getExposureValue = (key) => {
    if (!exposureData) return null;

    const keyMap = {
      dragon: 'ifDragonWins',
      tiger:  'ifTigerWins',
      lion:   'ifLionWins',

      dragon_black: 'ifDragonBlack', dragon_red: 'ifDragonRed',
      tiger_black:  'ifTigerBlack',  tiger_red:  'ifTigerRed',
      lion_black:   'ifLionBlack',   lion_red:   'ifLionRed',

      dragon_odd:  'ifDragonOdd',  dragon_even: 'ifDragonEven',
      tiger_odd:   'ifTigerOdd',   tiger_even:  'ifTigerEven',
      lion_odd:    'ifLionOdd',    lion_even:   'ifLionEven',

      dragon_a: 'ifDragonA', dragon_2: 'ifDragon2', dragon_3: 'ifDragon3',
      dragon_4: 'ifDragon4', dragon_5: 'ifDragon5', dragon_6: 'ifDragon6',
      dragon_7: 'ifDragon7', dragon_8: 'ifDragon8', dragon_9: 'ifDragon9',
      dragon_10: 'ifDragon10', dragon_j: 'ifDragonJ', dragon_q: 'ifDragonQ', dragon_k: 'ifDragonK',

      tiger_a: 'ifTigerA', tiger_2: 'ifTiger2', tiger_3: 'ifTiger3',
      tiger_4: 'ifTiger4', tiger_5: 'ifTiger5', tiger_6: 'ifTiger6',
      tiger_7: 'ifTiger7', tiger_8: 'ifTiger8', tiger_9: 'ifTiger9',
      tiger_10: 'ifTiger10', tiger_j: 'ifTigerJ', tiger_q: 'ifTigerQ', tiger_k: 'ifTigerK',

      lion_a: 'ifLionA', lion_2: 'ifLion2', lion_3: 'ifLion3',
      lion_4: 'ifLion4', lion_5: 'ifLion5', lion_6: 'ifLion6',
      lion_7: 'ifLion7', lion_8: 'ifLion8', lion_9: 'ifLion9',
      lion_10: 'ifLion10', lion_j: 'ifLionJ', lion_q: 'ifLionQ', lion_k: 'ifLionK',
    };

    const val = exposureData[keyMap[key] ?? key];
    if (val === undefined || val === 0) return null;
    return val;
  };

  // ─── Bet handler ────────────────────────────────────────────────────────
  const handleNumberBoxClick = (value, rowLabel, positionIndex) => {
    if (locked) return;

    const position = positions[positionIndex].toUpperCase();
    let betType = '';
    let selection = '';

    if (rowLabel === 'Winner') {
      betType = 'MAIN';
      selection = position;
    } else {
      betType = 'SIDE';
      switch (rowLabel) {
        case 'Black': selection = `${position}_BLACK`; break;
        case 'Red':   selection = `${position}_RED`;   break;
        case 'Odd':   selection = `${position}_ODD`;   break;
        case 'Even':  selection = `${position}_EVEN`;  break;
        default:      selection = `${position}_${rowLabel.toUpperCase()}`;
      }
    }

    const betData = {
      label:     `${rowLabel} (${positions[positionIndex]})`,
      odds:      parseFloat(value),
      betType,
      selection,
    };

    setSelectedBet(betData);
    setBetDialogOpen(true);
    if (onBetSelect) onBetSelect(betData);
  };

  const handleBetScreenClose = () => {
    setBetDialogOpen(false);
    setSelectedBet(null);
  };

  // ─── Render ─────────────────────────────────────────────────────────────
  return (
   
      <Box>
        {/* Game Screen */}
        <Box sx={{ position: 'relative', width: '100%' }}>
  <GameScreen
    bettingClosed={socketData?.bettingClosed === true}
    animationTime={typeof socketData?.animationTime === 'number' ? socketData.animationTime : undefined}
    socketData={socketData}
    settledData={settledData}
    remainingTime={remainingTime}
  />
  <Box sx={{ position: 'absolute', bottom: '8px', right: '8px',  zIndex: 10 }}>
    <FlipClock
      time={socketData?.bettingClosed ? 0 : (socketData?.remainingTime)}
    />
  </Box>
</Box>

        {/* Betting Table */}
        <Box className={styles.box}>
          <Box className={styles.box2}>

            {/* Header: Dragon | Tiger | Lion */}
            <Box className={styles.cardBox}>
              {positions.map((position, index) => (
                <Box key={index} className={styles.card}>
                  <Typography className={styles.cardText}>{position}</Typography>
                </Box>
              ))}
            </Box>

            {/* Winner / Black / Red / Odd / Even rows */}
            {rowConfigs.map((row) => (
              <Box key={row.label} className={styles.casinoBox}>
                <Box className={styles.fontBox}>
                  {row.icons ? (
                    <Box className={styles.fontBoxInner}>
                      <Typography className={styles.casinoText}>{row.label}</Typography>
                      {row.icons.map((icon, i) => (
                        <img key={i} src={icon} alt={`${row.label}${i}`} />
                      ))}
                    </Box>
                  ) : (
                    <Typography className={styles.casinoText}>{row.label}</Typography>
                  )}
                </Box>

                {row.values.map((val, i) => (
                  <Box
                    key={i}
                    className={styles.NumberBox}
                    onClick={() => handleNumberBoxClick(val, row.label, i)}
                    sx={{ cursor: locked ? 'not-allowed' : 'pointer', position: 'relative', overflow: 'hidden' }}
                  >
                    <Typography className={styles.numberText}>{val}</Typography>
                    {/* ✅ Exposure Label */}
                    <ExposureLabel value={getExposureValue(row.betTypes[i])} />
                    {locked && (
                      <Box className={styles.bettinglocked_icon_container}>
                        <LockSVG />
                      </Box>
                    )}
                  </Box>
                ))}
              </Box>
            ))}

            {/* Card rows: A, 2 ... K */}
            {cardRows.map((row, index) => (
              <Box key={index} className={styles.casinoBox}>
                <Box className={styles.fontBox}>
                  <Box className={styles.CardBoxInner}>
                    <Typography className={styles.casinoCardText}>{row.label}</Typography>
                    <Box className={styles.cardIconBox}>
                      {row.icons.map((iconPair, idx) => (
                        <Box key={idx} className={styles.cardIconBox2}>
                          <img src={iconPair[0]} alt={`icon1-${row.label}-${idx}`} />
                          <img src={iconPair[1]} alt={`icon2-${row.label}-${idx}`} />
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Box>

                {row.values.map((val, i) => (
                  <Box
                    key={i}
                    className={styles.NumberBox}
                    onClick={() => handleNumberBoxClick(val, row.label, i)}
                    sx={{ cursor: locked ? 'not-allowed' : 'pointer', position: 'relative' }}
                  >
                    <Typography className={styles.numberText}>{val}</Typography>
                    {/* ✅ Exposure Label */}
                    <ExposureLabel value={getExposureValue(row.betTypes[i])} />
                    {locked && (
                      <Box className={styles.bettinglocked_icon_container}>
                        <LockSVG />
                      </Box>
                    )}
                  </Box>
                ))}
              </Box>
            ))}

          </Box>
        </Box>

        <FooterLinks
          socketData={socketData}
          settledData={settledData}
          gameType="Dragon_Tiger_Lion"
        />
      </Box>
    
  );
}

export default DragonTigerLion;